module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "loginModal",
    staticStyle: {
      "visibility": "hidden",
      "position": "absolute",
      "left": "-999em"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.forgotPassword($event)
      }
    }
  }, [_vm._v("Forgot password?")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Username",
      "id": "username"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-feedback"
  }, [_c('i', {
    staticClass: "fa fa-user text-muted"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "id": "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-feedback"
  }, [_c('i', {
    staticClass: "fa fa-lock text-muted"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be3f92b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginModal.vue
// module id = 367
// module chunks = 0